import React from 'react';

export const Info = (props) => (
  <svg
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="7" cy="7" fill="#74729D" r="6.5" stroke="#74729D" />
    <path
      d="M6.39034 10V5.944H7.59834V10H6.39034ZM6.34234 4.04H7.64634V5.176H6.34234V4.04Z"
      fill="white"
    />
  </svg>
);
